import React from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import _ from "lodash";
import Footer from "./Footer";
import Seo from "./Seo";
import POIItem from "./POIItem";
import {trackLinkClick} from "../helpers";


class BikeRentals extends React.Component {
    title = () => {
        return "Bike shops & rentals in Bristol, Bath & NE Somerset, North Somerset, and South Gloucestershire";
    };

    desc = () => {
        return "Find out where to rent a bike in Bristol, Bath & NE Somerset, North Somerset, and South Gloucestershire. Or checkout our loan bike scheme.";
    };

    render() {
        const valid_locations = _.filter(
            this.props.locations,
            (location) => location.lat && location.lng
        );
        if (this.props.map.userLocation) {
            valid_locations.push(this.props.map.userLocation);
        }

        return (
            <div>
                <Seo title={this.title()} desc={this.desc()} />

                <CSSTransitionGroup
                    transitionName="slide-fade"
                    transitionAppear={true}
                    transitionAppearTimeout={400}
                    transitionEnterTimeout={400}
                    transitionLeaveTimeout={400}
                >
                    <div className="bike-rental-wrapper">
                        <header className="bike-rental-header">
                            <h1 className="main-title">Bike shops & rentals</h1>
                            <p className="tagline">
                                A list of bike shops, repairs and bike hire
                                providers in and around Bristol, Bath and the
                                West of England.
                            </p>
                        </header>
                        <div className="bike-rental">
                            <svg className="tab-illustration">
                                <use xlinkHref="#ill-bike-rentals" />
                            </svg>
                            <h2 className="sub-title">Locations</h2>

                            <div className="bike-rental__section">
                                <div className="bike-rental__shops">
                                    <h3 className="underline-heading">
                                        Bike Shop & Repairs
                                    </h3>
                                    <POIItem
                                        poiType="cycleShopsAndRepairs"
                                        label="Show on map"
                                        {...this.props}
                                    />
                                </div>
                                <p>Find local bike shops and repairs</p>
                                <a
                                    href="https://betterbybike.info/shops-and-repair/bike-shops/?location=North%20Somerset,Bath,Bristol,South%20Gloucestershire,&category=Secondhand%20bikes,New%20bikes,E-Bikes,Custom%20bikes"
                                    className="forward-title"
                                    onClick={ event => trackLinkClick(event) }
                                >
                                    Visit our Bike shops page
                                    <svg>
                                        <use xlinkHref="#right-arrow-go" />
                                    </svg>
                                </a>
                            </div>

                            <div className="bike-rental__section">
                                <h3 className="underline-heading">Bike Rental</h3>
                                <p>Hire a bike by the minute, hour or by the day</p>
                                <a
                                    href="https://betterbybike.info/rent-a-bike/bike-hire-tours/?location=North%20Somerset,Bath,Bristol,South%20Gloucestershire,&category=Bike%20hire"
                                    className="forward-title"
                                    onClick={ event => trackLinkClick(event) }
                                >
                                    Visit our Bike rental page
                                    <svg>
                                        <use xlinkHref="#right-arrow-go" />
                                    </svg>
                                </a>
                            </div>

                            <div className="bike-rental__section">
                                <h3 className="underline-heading">
                                    Loan Bike Scheme
                                </h3>
                                <p>
                                    Want to commute to work but need a bike? Weekly
                                    and monthly hire for people wanting to start
                                    cycling with the council funded Borrow a bike
                                    scheme.
                                </p>
                                <a
                                    href="https://betterbybike.info/schemes-and-initiatives/borrow-a-bike-scheme/"
                                    className="forward-title"
                                    onClick={ event => trackLinkClick(event) }
                                >
                                    Visit the Borrow a bike scheme page
                                    <svg>
                                        <use xlinkHref="#right-arrow-go" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <Footer />
                    </div>
                </CSSTransitionGroup>
            </div>
        );
    }
}

export default BikeRentals;



// WEBPACK FOOTER //
// ./src/components/BikeRentals.js